import { useT } from '@transifex/react'
import { STEPS } from '../types'
import type { StepBreadcrumbsProps } from './StepBreadcrumbs'

export const useStepBreadcrumbsModel = ({
  step,
  isAddingCustomer = false,
}: StepBreadcrumbsProps) => {
  const t = useT()

  const breadcrumbs = [
    t('Method', {
      _context: 'Breadcrumb for the fulfillment method step in the modal',
    }),
    t('Customer', {
      _context: 'Breadcrumb for the customer step in the modal',
    }),
    ...(isAddingCustomer
      ? [
          t('Add', {
            _context: 'Breadcrumb for the add step in the fulfillment modal',
          }),
        ]
      : []),
    t('Fulfillment details', {
      _context:
        'Breadcrumb for the fulfillment details step in the fulfillment modal',
    }),
  ]

  return {
    activeStep:
      step === STEPS.DETAILS && !isAddingCustomer ? step - 2 : step - 1,
    breadcrumbs,
  }
}
